import Popup from 'reactjs-popup';
import Select from 'react-select'
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import { SectorDataDDL } from '../../../../Components/CommonDDL/SectorDataDDL';
import { WardNameDataDDL } from '../../../../Components/CommonDDL/WardNameDataDDL';
import { AssetDataDDL } from '../../../../Components/CommonDDL/AssetDataDDL';
import { YesNoDataDDL } from '../../../../Components/CommonDDL/YesNoDataDDL';
import { useAuthState } from '../../../../Helper/Context';
import { useDispatch } from 'react-redux';
import { AssetTypeDataDDL } from '../../../../Components/CommonDDL/AssetTypeDataDDL';
import { GardenMasterPostDataAPI } from '../../../../Redux/MasterSlice/GardenMasterSlice';
import { isDisabled } from '@testing-library/user-event/dist/utils';
import { StatusNameDataDDL } from '../../../../Components/CommonDDL/StatusNameDataDDL';


export default function GardenWisemaintenanceStatusPopUp({ handleOnCloseClick, open, item, EditIcon, Flag, GardenMasterFlag, popupHeading, M_AssetTypeID, handleIsPost }) {

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch();

    const [rowData, setRowData] = useState(item)

    const [AreaName, setAreaName] = useState(Flag === 'Update' ? rowData.areaName : '');
    const [Area, setArea] = useState(Flag === 'Update' ? rowData.areaInSquareMetre : '');
    const [AssetName, setAssetName] = useState(Flag === 'Update' ? rowData.assetName : '');

    // console.log( M_AssetTypeID)

    const [SectorName, setSectorName] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_gD_SectorID : 0,
        Label: Flag === 'Update' ? rowData.sectorName : "Select...",
    })
    const [WardName, setWardName] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_WardID : 0,
        Label: Flag === 'Update' ? rowData.wardName : "Select...",

    })
    const [AssetType, setAssetType] = useState({
        DDL: [],
        ID: M_AssetTypeID,
        Label: Flag === 'Update' ? rowData.assetTypeName : "Select...",
    })
    const [GetPresent, setGetPresent] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.isGetPresent : 0,
        Label: Flag === 'Update' ? rowData.isGetPresentName : "Select...",

    })

    const [WateringEdgesPresent, setWateringEdgesPresent] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.isWateringOfEdgesPresent : 0,
        Label: Flag === 'Update' ? rowData.isWateringOfEdgesPresent : "Select...",
    })
    const [WateringTreePresent, setWateringTreePresent] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.isWateringOfTreesPresent : 0,
        Label: Flag === 'Update' ? rowData.isWateringOfTreesPresent : "Select...",

    })
    const [WateringLawnPresent, setWateringLawnPresent] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.isWateringOfLawnsPresent : 0,
        Label: Flag === 'Update' ? rowData.isWateringOfLawnsPresent : "Select...",

    })
    const [Status, setStatus] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_StatusID : 0,
        Label: Flag === 'Update' ? rowData.statusName : "Select...",

    })

    const handlePost = () => {
        const data = {
            M_AssetID: Flag === 'Update' ? rowData?.m_AssetID : '0',
            M_AssetTypeIDS: AssetType.ID,
            M_GD_SectorID: SectorName.ID,
            AssetName: AssetName,
            AreaName: AreaName,
            AreaInSquareMetre: Area,
            IsGetPresent: GetPresent.ID,
            IsWateringOfEdgesPresent: WateringEdgesPresent.ID,
            IsWateringOfTreesPresent: WateringTreePresent.ID,
            IsWateringOfLawnsPresent: WateringLawnPresent.ID,
            IsMaintingYou: WateringLawnPresent.ID,
            M_StatusID: Status.ID,
            M_UserID: UserID,
            token: token,
            Flag: Flag === 'Update' ? 'Update' : 'Insert',
            handleIsPost: handleIsPost,
            handleOnCloseClick:handleOnCloseClick
        }
        dispatch(GardenMasterPostDataAPI({ data }))
    }

    // const handleDeleteApi = (item) => {
    //   const data = {
    //     M_EmployeeID: item.m_EmployeeID,
    //     M_UserID: UserID,
    //     token: token,
    //     handleIsPost: handleIsPost
    //   }
    //   // dispatch(EmployeeDeleteAPI({ data }))
    // }

    // const { isDeleteLoading } = useSelector(state => state.EmployeeDeleteData)


    return (

        <Popup
            onOpen={() => setRowData(item)}
            contentStyle={{ width: '80%', height: '92%', top: '5%' }}
            className='master_pop_width'
            trigger={
                Flag === 'Update' ?
                    <i className="fa-solid fa-pen-to-square"
                        style={{ cursor: "pointer" }} title='Edit'
                    // onClick={() => console.log(rowData)}
                    >
                    </i> :
                    <i className="fa-solid fa-plus float-end btn btn-secondary mb-2"
                        style={{ color: "white" }}
                    >
                        <text className="ml-2 poppins">Add</text>
                    </i>
            }
            modal
        >

            {
                close => (
                    // n_popup-content 
                    <div className="mob_mas_pop modal-dialog modal-dialog-scrollable modal-xl">
                        <div className="modal-content">
                            <div className="modal-header pl-4 p-1">
                                <h4 className="modal-title" id="staticBackdropLabel">{popupHeading}</h4>
                                <button onClick={() => close()} className="btn-close m-1 mr-3" type="button" />
                            </div>

                            <div className="modal-body">
                                <div className='inner-modal-body'>

                                    <div className="row details-row">
                                        <div className="col-md-6 col-lg-4">
                                            <WardNameDataDDL
                                                WardName={WardName}
                                                setWardName={setWardName}
                                                Flag={Flag}
                                                rowData={rowData}
                                                IsDisabled={true}
                                            />
                                        </div>
                                        <div className="col-md-6 col-lg-4">
                                            <SectorDataDDL
                                                SectorName={SectorName}
                                                setSectorName={setSectorName}
                                                WardName={WardName}
                                                rowData={rowData}
                                                Flag={Flag}
                                                IsDisabled={true}
                                            />
                                        </div>

                                        <div className="col-md-6 col-lg-4">
                                            <AssetTypeDataDDL
                                                AssetType={AssetType}
                                                setAssetType={setAssetType}
                                                Flag={Flag}
                                                rowData={rowData}
                                                M_AssetTypeID={M_AssetTypeID}
                                                IsDisabled={true}
                                            />
                                        </div>

                                        <div className="col-md-6 col-lg-4">
                                            <div className="form-group">
                                                <label className="d-block" htmlFor="NameofDepartment">Asset Name</label>
                                                <input type="text"
                                                    className="form-control"
                                                    disabled
                                                    id="AssetName"
                                                    value={AssetName}
                                                    onChange={(e) => setAssetName(e.target.value)}



                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-6 col-lg-4">
                                            <div className="form-group">
                                                <label className="d-block" htmlFor="NameofDepartment">Area Name</label>
                                                <input type="text"
                                                    className="form-control"
                                                    disabled
                                                    id="AreaName"
                                                    value={AreaName}
                                                    onChange={(e) => setAreaName(e.target.value)}

                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-lg-4">
                                            <div className="form-group">
                                                <label className="d-block" htmlFor="NameofDepartment">Area (in sq meter)</label>
                                                <input type="text"
                                                    className="form-control"
                                                    disabled
                                                    id="Area"
                                                    value={Area}
                                                    onChange={(e) => setArea(e.target.value)}

                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-lg-4">
                                            <YesNoDataDDL
                                                GetPresent={GetPresent}
                                                setGetPresent={setGetPresent}
                                                DDLHeading='Get Present'
                                                Flag={Flag}
                                                rowData={rowData}
                                            />

                                        </div>
                                        <div className="col-md-6 col-lg-4">
                                            <YesNoDataDDL
                                                GetPresent={WateringEdgesPresent}
                                                setGetPresent={setWateringEdgesPresent}
                                                DDLHeading='Watering of Edges Present'
                                                Flag={Flag}
                                                rowData={rowData}
                                            />
                                        </div>
                                        <div className="col-md-6 col-lg-4">
                                            <YesNoDataDDL
                                                GetPresent={WateringTreePresent}
                                                setGetPresent={setWateringTreePresent}
                                                DDLHeading='Watering of Tree Present'
                                                Flag={Flag}
                                                rowData={rowData}
                                            />
                                        </div>
                                        <div className="col-md-6 col-lg-4">
                                            <YesNoDataDDL
                                                GetPresent={WateringLawnPresent}
                                                setGetPresent={setWateringLawnPresent}
                                                DDLHeading='Watering of Lawn Present'
                                                Flag={Flag}
                                                rowData={rowData}
                                            />
                                        </div>


                                        <div className="col-md-6 col-lg-4">
                                            <StatusNameDataDDL
                                                Status={Status}
                                                setStatus={setStatus}
                                                // rowData={item}
                                                rowData={rowData}
                                                Flag={Flag}
                                            />
                                        </div>
                                    </div>

                                    <div className="mb-4 pt-4">
                                        <h6 className="float-end">
                                            <button className="submit_btn"
                                                onClick={() => (handlePost("Insert"), close())}
                                            >
                                                {Flag === "Update" ? "Update" : "Save"}
                                            </button>
                                            <button className=" cancel_btn ms-2" onClick={() => close()} >Cancel</button>
                                        </h6>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                )}


        </Popup>
    )

}